import { AllowedCurrencyCode } from '@nrdy-marketing-engine/cart/@types/cart-state';
import { CatalogItem } from '@nrdy-marketing-engine/cart/@types/catalog-item';

interface ItemBuilderProps {
  catalogItem: CatalogItem;
  currencyCode: AllowedCurrencyCode;
  email: string;
  name: string;
  price: number;
  promoId?: string;
  studentId: string;
}

export default function itemBuilder({
  catalogItem,
  name,
  email,
  studentId,
  currencyCode,
  promoId,
  price,
}: ItemBuilderProps) {
  return {
    currency_code: currencyCode,
    duration_seconds: catalogItem.duration_seconds,
    item_id: catalogItem.id,
    item_type_id: catalogItem.item_type_id,
    list_price_cents: catalogItem.price_cents,
    price_cents: price,
    promotion_id: promoId,
    recommended_price_cents: catalogItem.price_cents,
    student: {
      email,
      id: studentId,
      name,
    },
  };
}
